export default __webpack_public_path__ + "static/media/setting.06a279de.svg";